export const parseDatetime = (date: string): string => `${date}T00:00:00`

export const dateObjectToString = (date: Date): string => date.toISOString().split('T')[0]

export const getTomorrowDateString = (): string => {
  const date = new Date()
  date.setDate(date.getDate() + 1)
  return dateObjectToString(date)
}

export const getTomorrowDateStringWithParam = (dateISO: string): number =>
  (Date.now() - new Date(dateISO).getTime()) / (1000 * 60 * 5)
